exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-1d8e824e],h2[data-v-1d8e824e]{font-weight:400}ul[data-v-1d8e824e]{list-style-type:none;padding:0}li[data-v-1d8e824e]{display:inline-block;margin:0 10px}a[data-v-1d8e824e]{color:#42b983}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d8e824e","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/lib/ScreenSet.vue
// module id = 4
// module chunks = 0